export const isValidDateString = (str: string) => {
  const dateRegex = /^(\d{2})\.(\d{2})\.(\d{4})$/
  const match = str.match(dateRegex)
  if (!match) return false

  const [ , dayStr, monthStr, yearStr ] = match
  const day = Number(dayStr)
  const month = Number(monthStr)
  const year = Number(yearStr)

  const isDayValid = day >= 1 && day <= 31
  const isMonthValid = month >= 1 && month <= 12
  const isYearValid = year >= 1900 && year <= 2099

  return isDayValid && isMonthValid && isYearValid
}
